import { useTheme } from "@emotion/react";
import { Avatar, Box, Grid, IconButton, Paper, Popover, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { useAppContext } from "../../App";
import { useAbm } from "../../services/abm";
import { dataToView } from "../details/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import { useLogin } from "../../services/login";

export const UserProfile = ({anchorEl, onClose}) => {
  
  const { palette } = useTheme();
  const [ userData, setUserData ] = useState();
  const appContext = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();
  const claims = appContext.claims;
  const signs = appContext.readSings();
  const ahora = Date.now() / 1000;
  const cuentasDisponibles = signs.filter(sign => sign.exp > ahora && sign.id !== claims?.id);
  const login = useLogin();

  const handleSwitch = (sign) => {
    onClose(); // cerrar el popover primero
    login.reloadToken({token: sign.token})
    .then(response => {
      appContext.singIn(sign, true); // usá reloadToken + singIn
      if (location.pathname === '/home') {
        window.location.href = '/home'; // 🔁 fuerza recarga total
      } else {
        navigate('/home'); // ✅ navegación SPA
      }
    })
    .catch(error => {
      console.log("error")
    });
  };
 
  const userId = claims?.id;
  const abm = useAbm({entity: "usuarios"});
  const open = Boolean(anchorEl);

  useEffect(() => {
    if(userId){
      abm.getAll({id: userId})
        .then(data => {
          //console.log(data.results[0])
          setUserData(data.results[0])
        })
    }
  }, [userId])

  return (
    <Popover
      id="user-profile"
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Box padding={1} maxWidth={300}>
        <Grid container spacing={2} padding={1}>
          <Grid item xs={12} display="flex" alignItems="center">
            <Avatar sx={{bgcolor: palette.primary.main, marginX: 2}}>{userData?.nombre_completo?.split(" ").slice(0, 2).map(s => s.substring(0,1))}</Avatar>
            <Box flex={1}>{userData?.nombre_completo}</Box>
          </Grid>
          <Grid item xs={12} display="flex">
            Email: {userData?.email}
          </Grid>
          <Grid item xs={12} display="flex">
            Rol: {userData?.rol}
          </Grid>
          <Grid item xs={12} display="flex">
            Centros: {userData?.centros && userData?.centros.join(", ")}
          </Grid>
          {cuentasDisponibles.length > 0 && (
            <>
              <Grid item xs={12}>
                <Box fontWeight="bold">Cambiar a otra cuenta:</Box>
              </Grid>
              {cuentasDisponibles.map((sign) => {
                const segundosRestantes = Math.floor(sign.exp - ahora);
                return (
                  <Grid item xs={12} key={sign.email}>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 1,
                        cursor: 'pointer',
                        '&:hover': { backgroundColor: 'action.hover' }
                      }}
                      onClick={() => handleSwitch(sign)}
                    >
                      <Box>
                        <Typography variant="subtitle2">{sign.nombre}</Typography>
                        <Typography variant="caption" color="text.secondary" display="block">{sign.rol}</Typography>
                      </Box>
                    </Paper>
                  </Grid>
                );
              })}
            </>
          )}

        </Grid>
      </Box>
    </Popover>
  )
}